<template>
  <svg
    xmlns="http://www.w3.org/2000/svg" 
  >
    <path fill-rule="evenodd" d="M5,8c0,.3.2.5.5.5h3.8l-1.1,1.1c-.2.2-.2.5,0,.7.2.2.5.2.7,0l2-2c.2-.2.2-.5,0-.7,0,0,0,0,0,0l-2-2c-.2-.2-.5-.2-.7,0-.2.2-.2.5,0,.7l1.1,1.1h-3.8c-.3,0-.5.2-.5.5"/>
    <path d="M3,0h10c1.1,0,2,.9,2,2v12c0,1.1-.9,2-2,2H3c-1.1,0-2-.9-2-2v-1h1v1c0,.6.4,1,1,1h10c.6,0,1-.4,1-1V2c0-.6-.4-1-1-1H3c-.6,0-1,.4-1,1v1h-1v-1C1,.9,1.9,0,3,0"/>
    <path d="M1,5v-.5c0-.3.2-.5.5-.5s.5.2.5.5v.5h.5c.3,0,.5.2.5.5s-.2.5-.5.5H.5c-.3,0-.5-.2-.5-.5s.2-.5.5-.5h.5ZM1,8v-.5c0-.3.2-.5.5-.5s.5.2.5.5v.5h.5c.3,0,.5.2.5.5s-.2.5-.5.5H.5c-.3,0-.5-.2-.5-.5s.2-.5.5-.5h.5ZM1,11v-.5c0-.3.2-.5.5-.5s.5.2.5.5v.5h.5c.3,0,.5.2.5.5s-.2.5-.5.5H.5c-.3,0-.5-.2-.5-.5s.2-.5.5-.5h.5Z"/>
  </svg>
</template>
